

<div fxLayout="row">
    <div fxFlex="fxFill">
        <kendo-formfield>
            <kendo-label [text]="caption | translate"></kendo-label>
            <kendo-textbox 
            [ngClass]="{'fx-fill': settings.fxFill}"  
            [formControl]="control"
            (valueChange)="onChange($event)"
            > </kendo-textbox>
        </kendo-formfield>
    </div>
    <div fxFlex="32px"  fxLayoutAlign="center center">
     <kendo-icon  *ngIf="this.control.value" class="pointer" [name]="'redo'" (click)="navigateToUrl()"></kendo-icon>
   </div>
   
</div>

